import { formatDate, getYearsText } from "../helpers/helpers";

export default class Validate {
    static #required(value) {
        if (value) {
            return true;
        }

        return false;
    }

    static #number(value) {
        if (!value) {
            return true;
        }

        if (isFinite(value)) {
            return true;
        }

        return false;
    }

    static #matches(value, regex) {
        if (!value) {
            return true;
        }

        if (regex.test(value)) {
            return true;
        }

        return false;
    }
    

    static #time(value) {
        if (!value) {
            return true;
        }
        const time = value.split(":");

        return this.#isTimeValid(time);
    }

    static #isTimeValid(dateArray) {
        if (dateArray.length !== 3) {
            return false;
        }

        if (isNaN(+dateArray[0])) {
            return false;
        }

        if (isNaN(+dateArray[1])) {
            return false;
        }

        if (isNaN(+dateArray[2])) {
            return false;
        }

        if (+dateArray[0] > 23 || +dateArray[2] < 0) {
            return false;
        }
        
        if (+dateArray[1] > 59 || +dateArray[2] < 0) {
            return false;
        }

        if (+dateArray[2] > 59 || +dateArray[2] < 0) {
            return false;
        }

        if (+dateArray[0] === 0 && +dateArray[1] === 0 && +dateArray[2] === 0) {
            return false;
        }

        return true;
    }

    static #date(value) {
        if (!value) {
            return true;
        }
        const date = value.split(".");

        return this.isDateValid(date);
    }

    static isDateValid(dateArray) {
        const maxTime = 253397883600000;

        if (dateArray.length !== 3) {
            return false;
        }

        if (!dateArray[2]) {
            return false;
        }

        // Проверка на года от 1 до 99 - js с ними не дружит
        if (dateArray[2].length < 3) {
            return false;
        }

        if (isNaN(+dateArray[0])) {
            return false;
        }

        if (isNaN(+dateArray[1])) {
            return false;
        }

        if (isNaN(+dateArray[2])) {
            return false;
        }

        if (+dateArray[2] <= 100) {
            return false;
        }

        if (+dateArray[1] < 1 || +dateArray[1] > 12) {
            return false;
        }

        // Месяца с 31 днем в году
        if (
            +dateArray[1] === 1 ||
            +dateArray[1] === 3 ||
            +dateArray[1] === 5 ||
            +dateArray[1] === 7 ||
            +dateArray[1] === 8 ||
            +dateArray[1] === 10 ||
            +dateArray[1] === 12
        ) {
            if (+dateArray[0] < 1 || +dateArray[0] > 31) return false;
        }

        // Месяца с 30 днем в году
        if (+dateArray[1] === 4 || +dateArray[1] === 6 || +dateArray[1] === 9 || +dateArray[1] === 11) {
            if (+dateArray[0] < 1 || +dateArray[0] > 30) return false;
        }

        // Проверка на количество дней в феврале
        if (+dateArray[1] === 2) {
            if ((0 == +dateArray[2] % 4 && 0 != +dateArray[2] % 100) || 0 == +dateArray[2] % 400) {
                if (+dateArray[0] < 1 || +dateArray[0] > 29) return false;
            } else {
                if (+dateArray[0] < 1 || +dateArray[0] > 28) return false;
            }
        }

        const valueDateTime = new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]).getTime();

        // Проверка на число более 9999
        if (valueDateTime >= maxTime) {
            return false;
        }

        return true;
    }

    static #inAdulthood(value) {
        if (!value) {
            return true;
        }

        const today = new Date();
        const dateArray = value.split(".");

        if (
            Math.floor(
                (today.getTime() - new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]).getTime()) /
                    1000 /
                    60 /
                    60 /
                    24 /
                    365.25
            ) < 18
        ) {
            return false;
        }
        return true;
    }

    static #minAge(date, num) {
        if (!date) {
            return true;
        }

        if (!num) {
            return true;
        }

        const today = new Date();
        const dateArray = date.split(".");

        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = +today.getFullYear() - num;

        const minAgeDate = new Date(`${year}.${month}.${day}`);

        if (new Date(dateArray.reverse().join(".")).getTime() >= minAgeDate.getTime()) {
            return false;
        }

        return true;
    }

    static #maxAge(date, num) {
        if (!date) {
            return true;
        }

        if (!num) {
            return true;
        }

        const today = new Date();
        const dateArray = date.split(".");

        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = +today.getFullYear() - num;

        const maxAgeDate = new Date(`${year}.${month}.${day}`);

        if (new Date(dateArray.reverse().join(".")).getTime() <= maxAgeDate.getTime()) {
            return false;
        }

        return true;
    }

    static #inTeens(value) {
        if (!value) {
            return true;
        }

        const today = new Date();
        const dateArray = value.split(".");

        if (
            Math.floor(
                (today.getTime() - new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]).getTime()) /
                    1000 /
                    60 /
                    60 /
                    24 /
                    365.25
            ) < 14
        ) {
            return false;
        }
        return true;
    }

    static #before(value, date) {
        if (!value) {
            return true;
        }

        if (!date) {
            return true;
        }

        const valueArray = value.split(".");

        const valueDateTime = new Date(+valueArray[2], +valueArray[1] - 1, +valueArray[0]).getTime();
        const dateDateTime = date.getTime();

        return valueDateTime < dateDateTime;
    }

    static #after(value, date) {
        if (!value) {
            return true;
        }

        if (!date) {
            return true;
        }

        const valueArray = value.split(".");

        const valueDateTime = new Date(+valueArray[2], +valueArray[1] - 1, +valueArray[0]).getTime();
        const dateDateTime = date.getTime();

        return valueDateTime > dateDateTime;
    }

    static #beforeEquals(value, date)  {
        if(!value) {
            return true;
        }

        if(!date) {
            return true;
        }

        const valueArray = value.split(".");

        const valueDateTime = new Date(+valueArray[2], +valueArray[1] - 1, +valueArray[0]).getTime();
        const dateDateTime = date.getTime();

        return valueDateTime <= dateDateTime;
    }

    static #afterEquals(value, date)  {
        if(!value) {
            return true;
        }

        if(!date) {
            return true;
        }

        const valueArray = value.split(".");

        const valueDateTime = new Date(+valueArray[2], +valueArray[1] - 1, +valueArray[0]).getTime();
        const dateDateTime = date.getTime();
        
        return valueDateTime >= dateDateTime;
    }

    static #min(value, num) {
        if (!value) {
            return true;
        }

        if (!num) {
            return true;
        }

        if (value.length >= num) {
            return true;
        }

        return false;
    }

    static #minValue(value, num) {
        if (!value) {
            return true;
        }

        if (!num) {
            return true;
        }

        if (+value >= +num) {
            return true;
        }

        return false;
    }

    static #max(value, num) {
        if (!value) {
            return true;
        }

        if (!num) {
            return true;
        }

        if (value.length <= num) {
            return true;
        }

        return false;
    }

    static #maxValue(value, num) {
        if (!value) {
            return true;
        }

        if (!num) {
            return true;
        }

        if (+value <= +num) {
            return true;
        }

        return false;
    }

    static #validateSnils(value) {
        if (!value) {
            return true;
        }

        const snils = value.replaceAll(/\s+|\-/g, "");

        let sum = 0;

        for (let i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i);
        }

        let checkDigit = 0;

        if (sum < 100) {
            checkDigit = sum;
        } else if (sum > 101) {
            checkDigit = parseInt(sum % 101);
            if (checkDigit === 100) {
                checkDigit = 0;
            }
        }

        if (checkDigit === parseInt(snils.slice(-2))) {
            return true;
        }

        return false;
    }

    static #validateSameSnils(value, snils) {
        if (!value) {
            return true;
        }

        if (value.trim() === snils.trim()) {
            return false;
        }

        return true;
    }

    static #validateInn(value) {
        if (!value) {
            return true;
        }

        var checkDigit = function (inn, coefficients) {
            var n = 0;
            for (var i in coefficients) {
                n += coefficients[i] * inn[i];
            }
            return parseInt((n % 11) % 10);
        };

        switch (value.length) {
            case 10:
                var n10 = checkDigit(value, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
                if (n10 === parseInt(value[9])) {
                    return true;
                }
                break;
            case 12:
                var n11 = checkDigit(value, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                var n12 = checkDigit(value, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                if (n11 === parseInt(value[10]) && n12 === parseInt(value[11])) {
                    return true;
                }
                break;
        }

        return false;
    }

    static #firstLetterUppercase(value) {
        if (!value) {
            return false;
        }

        if (/^[A-ZА-Я]*$/.test(value[0])) {
            return true;
        }

        return false;
    }

    static #getRequiredValidationError(name) {
        switch (name) {
            default: {
                return "Поле обязательно для заполнения";
            }
        }
    }

    static #getNumberValidationError(name) {
        switch (name) {
            default: {
                return "Поле должно содержать только цифры";
            }
        }
    }

    static #getMatchesValidationError(name) {
        switch (name) {
            case "cyrilic": {
                return "Поле должно содержать только русские буквы";
            }

            case "latin": {
                return "Поле может содержать только латинские буквы";
            }

            case "latin_and_numbers": {
                return "Поле может содержать только латинские буквы и цифры";
            }

            case "cyrilic_and_numbers": {
                return "Поле может содержать русские буквы и цифры";
            }

            case "email_example": {
                return "Вы ввели некорректный email ! Пример : home@hotmail.com";
            }

            case "transaction_summ":
            case "credit_payment_delayed_transaction_summ":
            case "credit_debt_payment_delayed_transaction_summ":
            case "debt_fine":
            case "deposit_summ":
            case "deposit_summ_deficit": {
                return "Укажите сумму с копейками, 1 или 2 цифры после запятой";
            }

            default: {
                return "В поле содержатся запрещенные символы";
            }
        }
    }

    static #getDateValidationError(name) {
        switch (name) {
            default: {
                return "Вы ввели неверную дату";
            }
        }
    }

    static #getTimeValidationError(name) {
        switch (name) {
            default: {
                return "Вы ввели неверное время";
            }
        }
    }

    static #getMinAgeValidationError(name, num) {
        switch (name) {
            default: {
                return `Клиент не достиг ${getYearsText(num)}`;
            }
        }
    }

    static #getMaxAgeValidationError(name, num) {
        switch (name) {
            default: {
                return `Клиенту больше ${getYearsText(num)}`;
            }
        }
    }

    static #getInAdulthoodValidationError(name) {
        switch (name) {
            default: {
                return "Нет 18 лет";
            }
        }
    }

    static #getBeforeValidationError(name, date) {
        switch (name) {
            case "yesterday": {
                const yesterday = new Date(date.getTime() - 86400000);
                return `Выберите дату ранее ${formatDate(yesterday)}`;
            }
            default: {
                return `Выберите дату ранее ${formatDate(date)}`;
            }
        }
    }

    static #getAfterValidationError(name, date) {
        switch (name) {
            case "yesterday": {
                const yesterday = new Date(date.getTime() - 86400000);
                return `Выберите дату после ${formatDate(yesterday)}`;
            }
            default: {
                return `Выберите дату после ${formatDate(date)}`;
            }
        }
    }

    static #getMinValidationError(name, num) {
        switch (name) {
            case "digits": {
                return `Поле должно содержать ${num} цифр`;
            }

            case "passport_subdivision_code": {
                return `Поле должно содержать 6 цифр`;
            }

            case "snils": {
                return `Поле должно содержать 16 цифр`;
            }

            case "phone": {
                return `Поле должно содержать 11 цифр`;
            }

            case "card_number": {
                return `Поле должно содержать 16 цифр`;
            }

            default: {
                return `Поле должно содержать ${num} символов`;
            }
        }
    }

    static #getMinValueValidationError(name, num) {
        switch (name) {
            default: {
                return `Значение должно быть больше ${num}`;
            }
        }
    }

    static #getMaxValidationError(name, num) {
        switch (name) {
            case "digits": {
                return `Поле не должно содержать больше ${num} цифр`;
            }

            default: {
                return `Поле не должно содержать больше ${num} символов`;
            }
        }
    }

    static #getMaxValueValidationError(name, num) {
        switch (name) {
            default: {
                return `Значение должно быть меньше ${num}`;
            }
        }
    }

    static #getInnValidationError(name) {
        switch (name) {
            default: {
                return `Неверный инн`;
            }
        }
    }

    static #getSnilsValidationError(name) {
        switch (name) {
            default: {
                return `Неверный снилс`;
            }
        }
    }

    static #getFirstLetterUppercaseValidationError(name) {
        switch (name) {
            default: {
                return `Первый символ должен быть заглавной буквой`;
            }
        }
    }

    static validate({ validationArray, value, name, mask }) {
        let message;
        let optional = false;

        if(value && mask) {
            if(mask.mask) {
                value = value.replaceAll(mask.placeholder, "");
            }
        }

        validationArray.forEach((validation) => {
            if (message) {
                return;
            }

            switch (validation[0]) {
                case "required": {
                    if (!this.#required(value)) {
                        message = this.#getRequiredValidationError(name);
                    }
                    break;
                }

                case "optional": {
                    message = null;
                    break;
                }

                case "number": {
                    if (!this.#number(value)) {
                        message = this.#getNumberValidationError(name);
                    }
                    break;
                }

                case "matches": {
                    if (!this.#matches(value, validation[1])) {
                        message = this.#getMatchesValidationError(name);
                    }
                    break;
                }

                case "date": {
                    if (!this.#date(value)) {
                        message = this.#getDateValidationError(name);
                    }
                    break;
                }

                case "minAge": {
                    if (!this.#minAge(value, validation[1])) {
                        message = this.#getMinAgeValidationError(name, validation[1]);
                    }
                    break;
                }

                case "maxAge": {
                    if (!this.#maxAge(value, validation[1])) {
                        message = this.#getMaxAgeValidationError(name, validation[1]);
                    }
                    break;
                }

                case "inAdulthood": {
                    if (!this.#inAdulthood(value)) {
                        message = this.#getInAdulthoodValidationError(name);
                    }
                    break;
                }

                case "before": {
                    if (!this.#before(value, validation[1])) {
                        message = this.#getBeforeValidationError(name, validation[1]);
                    }
                    break;
                }

                case "after": {
                    if (!this.#after(value, validation[1])) {
                        message = this.#getAfterValidationError(name, validation[1]);
                    }
                    break;
                }

                case "beforeEquals": {
                    if (!this.#beforeEquals(value, validation[1])) {
                        message = this.#getBeforeValidationError(name, validation[1]);
                    }
                    break;
                }

                case "afterEquals": {
                    if (!this.#afterEquals(value, validation[1])) {
                        message = this.#getAfterValidationError(name, validation[1]);
                    }
                    break;
                }

                case "min": {
                    if (!this.#min(value, validation[1])) {
                        message = this.#getMinValidationError(name, validation[1]);
                    }
                    break;
                }

                case "max": {
                    if (!this.#max(value, validation[1])) {
                        message = this.#getMaxValidationError(name, validation[1]);
                    }
                    break;
                }

                case "minValue": {
                    if (!this.#minValue(value, validation[1])) {
                        message = this.#getMinValueValidationError(name, validation[1]);
                    }
                    break;
                }

                case "maxVlaue": {
                    if (!this.#maxValue(value, validation[1])) {
                        message = this.#getMaxValueValidationError(name, validation[1]);
                    }
                    break;
                }

                case "inn": {
                    if (!this.#validateInn(value)) {
                        message = this.#getInnValidationError(name);
                    }
                    break;
                }

                case "snils": {
                    if (!this.#validateSnils(value)) {
                        message = this.#getSnilsValidationError(name);
                    }
                    break;
                }

                case "firstLetterUppercase": {
                    if (!this.#firstLetterUppercase(value)) {
                        message = this.#getFirstLetterUppercaseValidationError(name);
                    }
                    break;
                }

                case "time": {
                    if (!this.#time(value)) {
                        message = this.#getTimeValidationError(name);
                    }
                    break;
                }
            }
        });

        if (message) {
            return message;
        }

        return null;
    }
}
